export const DOMAIN = "https://denverfurnacerepair.com";
export const CTA_URL = "https://fatwalletinternetmarketing.com/visibilityready-demonstrations.html";
export const BIZ = "Denver Furnace Repair";
export const BIZ_FULL = "Denver Furnace Repair (Demo Purposes Only)";

export const NAV = [
  { label: "Services", to: "/services" },
  { label: "Repair or Replace", to: "/guides/repair-vs-replace" },
  { label: "Symptom Guide", to: "/guides/furnace-symptoms" },
  { label: "Answer Hub", to: "/answer-hub" },
  { label: "Service Area", to: "/service-area" },
  { label: "Illustrative Work", to: "/illustrative-work" },
];

export const SERVICE_AREA = [
  "Denver", "Aurora", "Lakewood", "Englewood", "Littleton", "Arvada",
  "Wheat Ridge", "Westminster", "Centennial", "Highlands Ranch", "Golden", "Thornton",
];

export const LABELS = {
  "/services/furnace-repair": "furnace repair",
  "/services/furnace-maintenance": "furnace tune-ups and maintenance",
  "/services/carbon-monoxide-gas-safety": "CO and gas safety checks",
  "/guides/furnace-symptoms": "the furnace symptom guide",
  "/guides/repair-vs-replace": "the repair-or-replace guide",
  "/guides/furnace-cost-factors": "furnace cost factors",
};

const I = (base, alt, w = 1264, h = 848, src = "AI-generated illustrative scene") => ({ base, alt, w, h, src });

export const IMG = {
  hero: I("hero-burners", "Blue gas burner flames glowing inside an open residential furnace cabinet in a dark basement"),
  homeHero: I("denver-home", "Brick bungalow on a snowy winter evening with warm light glowing from the windows and porch", 1536, 1024, "Owner-supplied illustrative scene"),
  noHeat: I("no-heat-thermostat", "Homeowner in a wool sweater adjusting a wall thermostat in a cold living room at night"),
  oldFurnace: I("old-furnace", "Aging standard-efficiency gas furnace with a rusted flue pipe in an unfinished basement"),
  newFurnace: I("new-furnace", "Newly installed high-efficiency condensing furnace with white PVC vent pipes in a tidy utility room"),
  flameSensor: I("flame-sensor", "Technician's gloved hand holding a furnace flame sensor near the burner assembly under flashlight"),
  analyzer: I("combustion-analyzer", "Technician using a handheld combustion analyzer probe in a furnace flue pipe"),
  heatPump: I("heat-pump-snow", "Cold-climate heat pump outdoor unit beside a brick home with light snow on the ground"),
  ductwork: I("ductwork", "Exposed galvanized ductwork and sealed trunk lines along an unfinished basement ceiling"),
  bungalow: I("case-bungalow", "Historic brick bungalow on a snowy winter evening with warm light in the windows"),
  upstairs: I("case-upstairs", "Homeowner kneeling to check airflow at a floor register in a cool upstairs bedroom"),
  tablet: I("tech-tablet", "Technician reviewing options on a tablet with a homeowner couple at a kitchen counter"),
  coAlarm: I("co-alarm", "Plug-in carbon monoxide alarm on a hallway wall outside a bedroom"),
  techRepair: I("tech-repair", "Technician kneeling at an open gas furnace testing the control board with a multimeter"),
  metro: I("metro-street", "Suburban residential street in winter with the Front Range mountains on the horizon"),
  skyline: I("denver-skyline", "Denver cityscape with snow-covered Rocky Mountains behind it", 1600, 1067, "Stock photograph (Unsplash), illustrative"),
  frost: I("frost-window", "Frost patterns covering a window pane in winter light", 1600, 2133, "Stock photograph (Unsplash), illustrative"),
  filter: I("dusty-filter", "Close-up of a dusty pleated furnace air filter", 1600, 1066, "Stock photograph (Unsplash), illustrative"),
  thermostatHands: I("thermostat-hands", "Hands holding a programmable thermostat removed from its wall plate", 1600, 1200, "Stock photograph (Unsplash), illustrative"),
  snowyHomes: I("snowy-homes", "Homes and evergreen trees covered in fresh snow", 1600, 1067, "Stock photograph (Unsplash), illustrative"),
};
